import type { ActivityLogOut } from '@repo/api-codegen';
import { Icon } from '@repo/foundations';
import { POLICY_ISSUE_STATUS_MAPPING } from '../constants';

export function IssueActivityLogIcon({
	activityLog,
}: {
	activityLog?: ActivityLogOut;
}) {
	let newStatus = null;
	if (!activityLog) {
		newStatus = 'started';
	} else {
		const { metadata } = activityLog;
		const status =
			metadata && 'new_status' in metadata ? metadata.new_status : undefined;

		if (status && typeof status === 'string') {
			const lowerStatus = status.toLowerCase();
			if (lowerStatus === 'resolved') {
				newStatus = 'resolved';
			} else if (lowerStatus === 'acknowledged') {
				newStatus = 'acknowledged';
			} else if (lowerStatus === 'ignored') {
				newStatus = 'ignored';
			} else {
				newStatus = 'open';
			}
		} else {
			newStatus = 'open';
		}
	}

	const { iconName, iconColor, iconFillColor } =
		POLICY_ISSUE_STATUS_MAPPING[newStatus];
	return <Icon name={iconName} color={iconColor} fillColor={iconFillColor} />;
}
